import { Flex } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Families from "./components/Families";

function Data() {

  return (
    <Flex direction="column" pt={{ base: "62px", md: "75px", xl: "88px" }}>
      <Families
      />
    </Flex>
  );
}

export default Data;
